import { render, staticRenderFns } from "./DataViewSidebarRisk.vue?vue&type=template&id=36b1f5b9&scoped=true&"
import script from "./DataViewSidebarRisk.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarRisk.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarRisk.vue?vue&type=style&index=0&id=36b1f5b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b1f5b9",
  null
  
)

export default component.exports